<div
  class="table-builder table-builder--responsive rounded-lg border border-gray-200 bg-white dark:border-dark-border dark:bg-dark-bg-secondary">
  <!-- Toolbar: responsive flex wrap -->
  <div
    class="table-builder-toolbar flex flex-wrap items-center gap-3 border-b border-gray-200 p-3 dark:border-dark-border">
    @if (mergedConfig().showSearch) {
    <div class="table-search-wrapper min-w-0 flex-1 basis-full sm:basis-0 sm:min-w-[180px] sm:max-w-md">
      <span class="table-search-icon" aria-hidden="true">
        <i class="iconify" data-icon="solar:magnifer-line-duotone"></i>
      </span>
      <input #searchInput type="search" [value]="searchTerm()" (input)="onSearchChange($any($event.target).value)"
        [placeholder]="mergedConfig().searchPlaceholder"
        class="table-search-input w-full rounded-xl border border-slate-300 bg-white py-2.5 pl-11 pr-4 text-sm text-gray-900 placeholder-gray-500 focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/15 dark:border-dark-border dark:bg-dark-bg-tertiary dark:text-dark-text dark:placeholder-dark-text-tertiary"
        [attr.aria-label]="'shared.tableBuilder.searchAria' | translate" />
    </div>
    }
    @if (mergedConfig().showStatusFilter) {
    <div class="flex items-center gap-2 min-w-0 shrink-0">
      <app-dropdown [label]="'shared.tableBuilder.status' | translate" [options]="statusFilterDropdownOptions()" [value]="statusFilterValue()"
        [placeholder]="'shared.tableBuilder.all' | translate" position="bottom" minWidth="160px" (valueChange)="onStatusFilterChange($event)" />
    </div>
    }
    @if (mergedConfig().showColumnFilters && filterableColumns().length > 0) {
    <button type="button" mat-icon-button (click)="toggleFiltersPanel()" [attr.aria-expanded]="filtersPanelOpen()"
      aria-label="Filtros por columna" matTooltip="Filtros por columna" class="table-filter-toggle-btn shrink-0"
      [class.text-emerald-600]="filtersPanelOpen()" [class.bg-emerald-100]="filtersPanelOpen()"
      [class.dark:bg-emerald-900]="filtersPanelOpen()" [class.dark:text-emerald-400]="filtersPanelOpen()"
      [class.text-gray-600]="!filtersPanelOpen()" [class.hover:bg-gray-200]="!filtersPanelOpen()"
      [class.dark:text-dark-text-secondary]="!filtersPanelOpen()"
      [class.dark:hover:bg-dark-bg-tertiary]="!filtersPanelOpen()">
      <mat-icon>filter_list</mat-icon>
    </button>
    }
    <div class="table-builder-toolbar-actions ml-auto flex flex-wrap items-center gap-2 min-w-0 shrink-0">
      @if (showToolbarExtra()) {
      <ng-content select="[tableBuilderToolbarExtra]"></ng-content>
      }
      @if (mergedConfig().showCreateButton && canCreate()) {
      <button type="button" (click)="emitCreate()"
        class="flex items-center gap-1.5 rounded-lg bg-emerald-600 px-3 py-2 text-sm font-medium text-white hover:bg-emerald-700 focus:outline-none">
        <mat-icon class="!text-lg !w-5 !h-5">add</mat-icon>
        <span class="hidden sm:inline text-white">{{ mergedConfig().createButtonLabel }}</span>
      </button>
      }
      @if (mergedConfig().showColumnToggle && toggleableColumns().length > 0) {
      <button type="button" mat-icon-button [matMenuTriggerFor]="columnsMenu" #columnMenuTrigger="matMenuTrigger"
        [matTooltip]="'shared.tableBuilder.toggleColumns' | translate" [attr.aria-label]="'shared.tableBuilder.toggleColumns' | translate"
        class="table-column-toggle-btn text-gray-600 hover:bg-gray-200 dark:text-dark-text-secondary dark:hover:bg-dark-bg-tertiary">
        <i class="iconify" data-icon="tabler:columns-3-filled"></i>
      </button>
      }
      @if (mergedConfig().showRefreshButton) {
      <button type="button" (click)="emitRefreshData()" mat-icon-button [matTooltip]="'shared.tableBuilder.refresh' | translate"
        [attr.aria-label]="'shared.tableBuilder.refresh' | translate">
        <i class="iconify" data-icon="solar:refresh-line-duotone"></i>
      </button>
      }
    </div>
  </div>

  @if (mergedConfig().showColumnFilters && filterableColumns().length > 0 && filtersPanelOpen()) {
  <div
    class="table-filters-panel border-b border-gray-200 bg-gray-50 px-3 py-4 dark:border-dark-border dark:bg-dark-bg-tertiary/50">
    <div class="flex items-center justify-between gap-4 mb-3 pb-2 border-b border-gray-200 dark:border-dark-border">
      <span class="text-sm font-medium text-gray-700 dark:text-dark-text-secondary">Filtros por columna</span>
      <button type="button" (click)="clearColumnFilters()"
        class="text-xs text-emerald-600 hover:underline dark:text-emerald-400">
        Limpiar todo
      </button>
    </div>
    <div class="table-filters-panel-grid">
      @for (col of filterableColumns(); track col.key) {
      <div class="table-filter-cell min-w-0">
        @switch (getColumnFilterType(col)) {
        @case ('select') {
        <app-dropdown [label]="col.label" [options]="columnFilterSelectOptions(col)"
          [value]="getColumnFilterSelectValue(col.key)" placeholder="Todos" position="bottom" minWidth="200px"
          (valueChange)="onColumnFilterSelectChange(col.key, $event)" />
        }
        @case ('text') {
        <div class="table-filter-row">
          <span class="table-filter-inline-label">{{ col.label }}</span>
          <input type="text" [value]="getColumnFilterStr(col.key)"
            (input)="setColumnFilter(col.key, $any($event.target).value || undefined)" placeholder="Contiene..."
            class="table-filter-input table-filter-input--grow rounded border border-gray-300 bg-white px-3 text-sm text-gray-900 placeholder-gray-500 dark:border-dark-border dark:bg-white dark:text-gray-900 dark:placeholder-gray-500" />
        </div>
        }
        @case ('number') {
        <div class="table-filter-row table-filter-row--wrap">
          <span class="table-filter-inline-label">{{ col.label }}</span>
          <div class="flex min-w-0 flex-1 flex-wrap gap-2">
            <input type="number" [value]="getColumnFilterMin(col.key)"
              (input)="setColumnFilterRange(col.key, 'min', $any($event.target).value !== '' ? +$any($event.target).value : undefined)"
              placeholder="Mín"
              class="table-filter-input min-w-[6rem] flex-1 rounded border border-gray-300 bg-white px-3 text-sm text-gray-900 dark:border-dark-border dark:bg-white dark:text-gray-900" />
            <input type="number" [value]="getColumnFilterMax(col.key)"
              (input)="setColumnFilterRange(col.key, 'max', $any($event.target).value !== '' ? +$any($event.target).value : undefined)"
              placeholder="Máx"
              class="table-filter-input min-w-[6rem] flex-1 rounded border border-gray-300 bg-white px-3 text-sm text-gray-900 dark:border-dark-border dark:bg-white dark:text-gray-900" />
          </div>
        </div>
        }
        @case ('currency') {
        <div class="table-filter-row table-filter-row--wrap">
          <span class="table-filter-inline-label">{{ col.label }}</span>
          <div class="flex min-w-0 flex-1 flex-wrap gap-2">
            <input type="number" [value]="getColumnFilterMin(col.key)"
              (input)="setColumnFilterRange(col.key, 'min', $any($event.target).value !== '' ? +$any($event.target).value : undefined)"
              placeholder="Mín"
              class="table-filter-input min-w-[6rem] flex-1 rounded border border-gray-300 bg-white px-3 text-sm text-gray-900 dark:border-dark-border dark:bg-white dark:text-gray-900" />
            <input type="number" [value]="getColumnFilterMax(col.key)"
              (input)="setColumnFilterRange(col.key, 'max', $any($event.target).value !== '' ? +$any($event.target).value : undefined)"
              placeholder="Máx"
              class="table-filter-input min-w-[6rem] flex-1 rounded border border-gray-300 bg-white px-3 text-sm text-gray-900 dark:border-dark-border dark:bg-white dark:text-gray-900" />
          </div>
        </div>
        }
        @case ('date') {
        <div class="table-filter-date-one-row">
          <div class="table-filter-date-pair">
            <span class="table-filter-date-pair__label">{{ col.label }} desde</span>
            <mat-form-field appearance="outline" class="table-filter-dp" subscriptSizing="dynamic"
              [hideRequiredMarker]="true">
              <input matInput [matDatepicker]="dpDesde" placeholder="dd/mm/aaaa"
                [ngModel]="getColumnFilterMinAsDate(col.key)" (ngModelChange)="onColumnFilterDatePick(col.key, 'min', $event)"
                [attr.aria-label]="col.label + ' desde'" />
              <mat-datepicker-toggle matIconSuffix [for]="dpDesde"></mat-datepicker-toggle>
              <mat-datepicker #dpDesde></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="table-filter-date-pair">
            <span class="table-filter-date-pair__label">{{ col.label }} hasta</span>
            <mat-form-field appearance="outline" class="table-filter-dp" subscriptSizing="dynamic"
              [hideRequiredMarker]="true">
              <input matInput [matDatepicker]="dpHasta" placeholder="dd/mm/aaaa"
                [ngModel]="getColumnFilterMaxAsDate(col.key)" (ngModelChange)="onColumnFilterDatePick(col.key, 'max', $event)"
                [attr.aria-label]="col.label + ' hasta'" />
              <mat-datepicker-toggle matIconSuffix [for]="dpHasta"></mat-datepicker-toggle>
              <mat-datepicker #dpHasta></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        }
        @case ('time') {
        <div class="table-filter-row table-filter-row--wrap">
          <span class="table-filter-inline-label">{{ col.label }}</span>
          <div class="flex min-w-0 flex-1 flex-wrap gap-2">
            <input type="time" [value]="getColumnFilterMinStr(col.key)"
              (input)="setColumnFilterRange(col.key, 'min', $any($event.target).value || undefined)"
              class="table-filter-input min-w-[6rem] flex-1 rounded border border-gray-300 bg-white px-3 text-sm text-gray-900 dark:border-dark-border dark:bg-white dark:text-gray-900" />
            <input type="time" [value]="getColumnFilterMaxStr(col.key)"
              (input)="setColumnFilterRange(col.key, 'max', $any($event.target).value || undefined)"
              class="table-filter-input min-w-[6rem] flex-1 rounded border border-gray-300 bg-white px-3 text-sm text-gray-900 dark:border-dark-border dark:bg-white dark:text-gray-900" />
          </div>
        </div>
        }
        @case ('boolean') {
        <app-dropdown [label]="col.label" [options]="booleanFilterOptions()" [value]="getColumnFilterBooleanValue(col.key)"
          [placeholder]="'shared.tableBuilder.all' | translate" position="bottom" minWidth="160px" (valueChange)="setColumnFilter(col.key, $event)" />
        }
        @default {
        <div class="table-filter-row">
          <span class="table-filter-inline-label">{{ col.label }}</span>
          <input type="text" [value]="getColumnFilterStr(col.key)"
            (input)="setColumnFilter(col.key, $any($event.target).value || undefined)" placeholder="Contiene..."
            class="table-filter-input table-filter-input--grow rounded border border-gray-300 bg-white px-3 text-sm text-gray-900 placeholder-gray-500 dark:border-dark-border dark:bg-white dark:text-gray-900 dark:placeholder-gray-500" />
        </div>
        }
        }
      </div>
      }
    </div>
  </div>
  }

  <mat-menu #columnsMenu="matMenu" class="table-column-menu" xPosition="before" panelClass="table-column-menu-panel">
    <div (click)="$event.stopPropagation()">
      <div class="table-column-menu-header px-4 py-2 text-sm font-medium text-gray-700 border-b border-gray-200">
        {{ 'shared.tableBuilder.visibleColumns' | translate }}
      </div>
      @for (col of toggleableColumns(); track col.key) {
      <button mat-menu-item type="button" (click)="toggleColumnVisibility(col.key)">
        <mat-checkbox class="column-visibility-checkbox" [checked]="isColumnVisible(col.key)"
          (click)="$event.preventDefault(); $event.stopPropagation(); toggleColumnVisibility(col.key)"
          color="primary"></mat-checkbox>
        <span class="ml-2 column-visibility-label">{{ col.label }}</span>
      </button>
      }
    </div>
  </mat-menu>


  <!-- Table: scroll horizontal en móvil, sticky primera columna y acciones -->
  <div class="table-builder-scroll overflow-x-auto overflow-y-visible -webkit-overflow-scrolling-touch">
    @if (paginatedData().length === 0) {
    <div
      class="flex items-center justify-center py-12 px-4 text-gray-500 dark:text-dark-text-tertiary text-center text-sm min-h-[50vh] flex-col gap-4">
      <img [src]="'assets/images/empty_records.webp'" alt="" class="size-40">
      <p class="text-gray-500 dark:text-dark-text-tertiary text-center text-base">{{ mergedConfig().emptyMessage }}</p>
    </div>
    } @else {
    <table class="table-builder-table w-full border-collapse text-left text-sm">
      <thead>
        <tr
          class="border-b border-gray-200 bg-gray-50 dark:border-dark-border dark:bg-dark-bg-tertiary"
          [class.table-thead-row--emerald]="mergedConfig().headerTone === 'emerald'"
        >
          @if (isRowExpansionEnabled()) {
          <th
            class="table-th table-th--expand w-9 px-1 py-2 text-center align-middle"
            [class.table-th--on-emerald]="mergedConfig().headerTone === 'emerald'"
            scope="col"
            [matTooltip]="'Clic en la fila o en el icono para ver o cerrar el detalle'"
            matTooltipPosition="above"
            aria-label="Detalle; expande u oculta al hacer clic en la fila o en la flecha"
          >
            <span
              class="table-expand-col-head"
              aria-hidden="true"
            >
              <i
                class="iconify"
                data-icon="solar:layers-minimalistic-bold-duotone"
              ></i>
            </span>
          </th>
          }
          @if (showSelection()) {
          <th class="table-th w-10 px-3 py-2">
            <mat-checkbox
              [checked]="allSelected()"
              [indeterminate]="someSelected()"
              (change)="toggleSelectAll()"
              color="primary">
            </mat-checkbox>
          </th>
          }
          @for (col of visibleColumns(); track col.key; let first = $first) {
          <th
            class="table-th px-3 py-2 font-medium text-gray-700 dark:text-dark-text-secondary"
            [class.table-th--sortable]="col.sortable"
            [class.table-th--sorted]="isColumnSorted(col)"
            [class.table-th--icon-only]="col.type === 'iconOnly'"
            [class.table-th--on-emerald]="mergedConfig().headerTone === 'emerald'"
            [class.table-th--wrap]="col.headerTooltip"
            [ngClass]="col.headerClass ?? ''"
            [matTooltip]="col.headerTooltip ?? ''"
            [matTooltipDisabled]="!col.headerTooltip"
            (click)="col.sortable ? toggleSort(col) : null"
            [attr.aria-sort]="isColumnSorted(col) ? (getSortIcon(col) === 'asc' ? 'ascending' : 'descending') : null"
          >
            <span class="table-th-content w-full">
              <span class="table-th-label">{{ col.label }}</span>
              @if (col.sortable) {
              <span class="table-th-sort" aria-hidden="true">
                <mat-icon class="table-sort-icon" [class.table-sort-icon--unsorted]="!isColumnSorted(col)">{{
                  getSortIconMatName(col) }}</mat-icon>
              </span>
              }
            </span>
          </th>
          }
          @if (hasActions()) {
          <th
            class="table-th table-th--sticky-actions w-10 sm:w-20 px-3 py-2 font-medium text-gray-700 dark:text-dark-text-secondary text-center sm:text-center"
            [class.table-th--on-emerald]="mergedConfig().headerTone === 'emerald'"
          >
            @if (isMobileView()) {
            <i class="iconify" data-icon="solar:bolt-line-duotone"></i>
            } @else {
            {{ 'shared.tableBuilder.actions' | translate }}
            }
          </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of paginatedData(); track trackByFn($index, row)) {
        <tr
          class="table-row border-b border-gray-100 transition-[background-color,box-shadow] duration-200 hover:bg-gray-50 dark:border-dark-border dark:hover:bg-dark-bg-tertiary"
          [class.table-row--expandable]="isRowExpansionEnabled()"
          [class.table-row--expanded]="isRowExpansionEnabled() && isRowExpanded(row)"
          [class.bg-emerald-50]="showSelection() && isRowSelected(row)"
          [class.dark:bg-emerald-900/10]="showSelection() && isRowSelected(row)">
          @if (isRowExpansionEnabled()) {
          <td
            class="table-td--expand w-9 px-1 py-1 align-middle text-center"
            [class.table-td--expand-open]="isRowExpanded(row)"
          >
            <button
              type="button"
              class="table-row-expand-btn"
              [class.table-row-expand-btn--open]="isRowExpanded(row)"
              (click)="$event.stopPropagation(); toggleRowExpansion(row)"
              [attr.aria-expanded]="isRowExpanded(row)"
              [attr.aria-label]="(isRowExpanded(row) ? 'Cerrar' : 'Abrir') + ' detalle de la fila'"
            >
              <span
                class="table-row-expand-chevron"
                [class.table-row-expand-chevron--open]="isRowExpanded(row)"
                aria-hidden="true"
              >
                <i class="iconify" data-icon="solar:alt-arrow-right-bold"></i>
              </span>
            </button>
          </td>
          }
          @if (showSelection()) {
          <td class="px-3 py-2 w-10">
            <mat-checkbox
              [checked]="isRowSelected(row)"
              (change)="toggleSelectRow(row)"
              color="primary">
            </mat-checkbox>
          </td>
          }
          @for (col of visibleColumns(); track col.key; let first = $first) {
          <td class="px-3 py-2 sm:px-4 sm:py-3 text-gray-900 dark:text-dark-text"
            [class.table-cell--clickable]="canToggleRowExpansion(col) || col.key === 'cv'"
            [class.table-cell--icon-only]="col.type === 'iconOnly'"
            [ngClass]="col.cellClass ?? ''"
            (click)="onCellClick(col, row)">
            @if (col.type === 'badgeText' && col.badgeVariant && col.badgeText) {
            <span class="table-badge-text">
              <span
                class="table-badge table-badge--{{ col.badgeVariant(getCellValue(row, col.key), row) }}"
                role="status"
              >
                {{ col.badgeText(getCellValue(row, col.key), row) }}
              </span>
              <span class="table-badge-text__label">
                {{ getDisplayValue(row, col) }}
              </span>
            </span>
            } @else if (col.type === 'badge' && col.badgeVariant) {
            <span class="table-badge table-badge--{{ col.badgeVariant(getCellValue(row, col.key), row) }}"
              role="status">
              {{ getDisplayValue(row, col) }}
            </span>
            } @else if (col.type === 'progress') {
            @let pct = getProgressPercent(row, col);
            <div class="table-progress" role="img" [attr.aria-label]="pct + ' por ciento'">
              <div class="table-progress__track">
                <div class="table-progress__fill" [style.width.%]="pct"></div>
              </div>
            </div>
            } @else if (col.type === 'iconOnly' && col.cellIcon) {
            <span
              class="inline-flex cursor-pointer items-center justify-center rounded-lg p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-dark-bg-tertiary dark:hover:text-gray-200"
              [attr.title]="col.label"
            >
              <i class="iconify text-xl" [attr.data-icon]="col.cellIcon"></i>
            </span>
            } @else {
            <span class="table-cell-content" [class.whitespace-nowrap]="col.type === 'currency' || col.type === 'number'">
              {{ getDisplayValue(row, col) }}
            </span>
            }
          </td>
          }
          @if (hasActions()) {
          <td class="table-td--sticky-actions px-2 py-2 sm:px-4">
            @if (getVisibleActionsCount(row) > maxInlineActions() || isMobileView()) {
            <button type="button" mat-button [matMenuTriggerFor]="rowActionsMenu" (click)="setActionsMenuRow(row)"
              class="!min-w-0 !px-2" aria-label="Acciones">
              <i class="iconify" data-icon="solar:menu-dots-bold"></i>
            </button>
            } @else {
            <div class="flex items-center gap-1">
              @if (rowActions().showView) {
              <button
                type="button"
                (click)="emitView(row)"
                mat-icon-button
                [matTooltip]="getViewActionLabel(row)"
                [attr.aria-label]="getViewActionLabel(row)"
                [disabled]="rowActions().viewDisabled?.(row) ?? false">
                <i class="iconify" data-icon="solar:eye-line-duotone"></i>
              </button>
              }
              @if (rowActions().showEdit && canEdit()) {
              <button type="button" (click)="emitEdit(row)" mat-icon-button [matTooltip]="'shared.tableBuilder.edit' | translate" [attr.aria-label]="'shared.tableBuilder.edit' | translate"
                [disabled]="rowActions().editDisabled?.(row) ?? false">
                <i class="iconify" data-icon="solar:pen-new-square-line-duotone"></i>
              </button>
              }
              @if (rowActions().showDelete && canDelete()) {
              <button type="button" (click)="emitDelete(row)" mat-icon-button appearance="outline"
                [matTooltip]="rowActions().deleteActionLabel ?? ('shared.tableBuilder.delete' | translate)"
                [attr.aria-label]="rowActions().deleteActionLabel ?? ('shared.tableBuilder.delete' | translate)"
                [disabled]="rowActions().deleteDisabled?.(row) ?? false">
                <i class="iconify" data-icon="solar:trash-bin-trash-line-duotone"></i>
              </button>
              }
              @for (action of extraRowActions(); track action.id) {
              @if (!action.visible || action.visible(row)) {
              @if (action.renderAs === 'button') {
              <button type="button" (click)="emitCustomAction(action.id, row)" [class]="action.buttonClass ?? ''"
                [matTooltip]="action.tooltip ?? action.label" [attr.aria-label]="action.label"
                [disabled]="action.disabled ? action.disabled(row) : false">
                @if (action.iconType === 'iconify') {
                <i class="iconify !w-5 !h-5" [attr.data-icon]="action.icon"></i>
                } @else {
                <mat-icon class="!text-lg !w-5 !h-5">{{ action.icon }}</mat-icon>
                }
                <span class="hidden sm:inline">{{ action.label }}</span>
              </button>
              } @else {
              <button type="button" (click)="emitCustomAction(action.id, row)" mat-icon-button
                [matTooltip]="action.tooltip ?? action.label" [attr.aria-label]="action.label"
                [disabled]="action.disabled ? action.disabled(row) : false">
                @if (action.iconType === 'iconify') {
                <i class="iconify" [attr.data-icon]="action.icon"></i>
                } @else {
                <mat-icon class="!text-lg !w-5 !h-5">{{ action.icon }}</mat-icon>
                }
              </button>
              }
              }
              }
            </div>
            }
          </td>
          }
        </tr>

        @if (isRowExpanded(row)) {
        <tr
          class="table-row-detail border-b border-gray-100 dark:border-dark-border"
          [class.table-row-detail--chips]="getRowExpansionRenderMode() === 'chips'"
        >
          <td class="table-row-detail__td px-3 sm:px-4" [attr.colspan]="getExpandedDetailColspan()">
            <div
              class="row-detail-container w-full max-w-full overflow-x-auto"
              [ngClass]="
                getRowExpansionRenderMode() === 'chips'
                  ? 'row-detail-container--chips'
                  : 'rounded-2xl border border-gray-200 bg-white p-3 sm:p-4 dark:border-dark-border dark:bg-dark-bg-secondary'
              "
            >
              @if (getRowExpansionRenderMode() === 'list') {
                <div class="flex flex-col gap-3">
                  <div class="text-sm font-semibold text-slate-700 dark:text-dark-text-secondary">
                    {{ getRowExpansionListTitle() }}
                  </div>
                  <ul class="flex flex-col gap-2">
                    @for (detail of getExpandedRowDetails(row); track detail.codigo) {
                      <li class="flex items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white px-3 py-2 dark:border-dark-border dark:bg-dark-bg-tertiary/40">
  <div class="min-w-0">
    <div class="text-sm font-medium text-slate-800 dark:text-dark-text truncate">
      {{ detail.tipo }}
    </div>
    <div class="text-xs text-slate-500 dark:text-dark-text-tertiary truncate">

      @if (getRowExpansionHeaders().codigo && getRowExpansionHeaders().codigo.trim() !== '') {
        <span class="font-medium">{{ getRowExpansionHeaders().codigo }}: </span>
      }
      {{ detail.codigo }} · {{ detail.descripcion }}

    </div>
  </div>

  @if (detail.actionLabel && detail.actionId) {
    <button
      type="button"
      (click)="emitDetailAction(detail.actionId, row, detail)"
      class="shrink-0 rounded-lg border border-emerald-600 bg-emerald-50/60 px-3 py-1.5 text-xs font-medium text-emerald-700 hover:bg-emerald-100/70 dark:border-emerald-500 dark:bg-emerald-900/20 dark:text-emerald-300 dark:hover:bg-emerald-900/35"
      aria-label="{{ detail.actionLabel }}"
    >
      {{ detail.actionLabel }}
    </button>
  }
</li>
                    }
                  </ul>
                </div>
              } @else if (getRowExpansionRenderMode() === 'chips') {
                <div class="table-row-chips">
                  @for (detail of getExpandedRowDetails(row); track detail.tipo) {
                    <div
                      class="table-row-chip-card"
                      [class.table-row-chip-card--action]="!!detail.actionId"
                      (click)="detail.actionId ? emitDetailAction(detail.actionId, row, detail) : null"
                    >
                      <div class="table-row-chip-card__top">
                        <div class="table-row-chip-card__head">
                          <span class="table-row-chip-card__icon" aria-hidden="true">
                            @if (detail.tipo.toLowerCase().includes('contrato')) {
                              <i class="iconify" data-icon="solar:document-text-bold-duotone"></i>
                            } @else if (detail.tipo.toLowerCase().includes('document')) {
                              <i class="iconify" data-icon="solar:folder-with-files-bold-duotone"></i>
                            } @else {
                              <i class="iconify" data-icon="solar:pen-new-square-bold-duotone"></i>
                            }
                          </span>
                          <span class="table-row-chip-card__title">{{ detail.tipo }}</span>
                        </div>
                        <div class="table-row-chip-card__status">
                          <span
                            class="table-row-chip-card__badge"
                            [ngClass]="'table-row-chip-card__badge--' + (detail.badgeVariant ?? 'neutral')"
                          >
                            {{ detail.codigo }}
                          </span>
                        </div>
                      </div>
                      <p class="table-row-chip-card__desc">{{ detail.descripcion }}</p>
                    </div>
                  }
                </div>
              } @else {
                <table class="row-detail-table w-full border-collapse text-left text-sm">
                  <thead>
                    <tr class="bg-emerald-700 text-white">
                      <th class="px-3 py-2 font-medium">{{ getRowExpansionHeaders().tipo }}</th>
                      <th class="px-3 py-2 font-medium">{{ getRowExpansionHeaders().codigo }}</th>
                      <th class="px-3 py-2 font-medium">{{ getRowExpansionHeaders().descripcion }}</th>
                      @if (hasExpandedRowDetailActions(row)) {
                        <th class="px-3 py-2 font-medium">{{ getRowExpansionHeaders().accion ?? 'Acción' }}</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (detail of getExpandedRowDetails(row); track detail.tipo) {
                    <tr class="border-b border-gray-200 last:border-b-0 dark:border-dark-border">
                      <td class="px-3 py-2 text-gray-700 dark:text-dark-text-secondary">{{ detail.tipo }}</td>
                      <td class="px-3 py-2 text-gray-700 dark:text-dark-text-secondary">{{ detail.codigo }}</td>
                      <td class="px-3 py-2 text-gray-700 dark:text-dark-text-secondary">{{ detail.descripcion }}</td>
                      @if (hasExpandedRowDetailActions(row)) {
                        <td class="px-3 py-2 text-right">
                          @if (detail.actionLabel && detail.actionId) {
                            <button
                              type="button"
                              (click)="emitDetailAction(detail.actionId, row, detail)"
                              class="rounded-lg border border-emerald-600 px-3 py-1.5 text-xs font-medium text-emerald-700 hover:bg-emerald-50 dark:border-emerald-500 dark:text-emerald-300 dark:hover:bg-emerald-900/20"
                              aria-label="{{ detail.actionLabel }}"
                            >
                              {{ detail.actionLabel }}
                            </button>
                          }
                        </td>
                      }
                    </tr>
                    }
                  </tbody>
                </table>
              }
            </div>
          </td>
        </tr>
        }
        }
      </tbody>
    </table>

    <mat-menu #rowActionsMenu="matMenu" class="table-builder-actions-menu" xPosition="before">
      @if (actionsMenuRow(); as row) {
      @if (rowActions().showView) {
      <button mat-menu-item (click)="emitView(row)" [disabled]="rowActions().viewDisabled?.(row) ?? false">
        <mat-icon>visibility</mat-icon>
        <span>{{ getViewActionLabel(row) }}</span>
      </button>
      }
      @if (rowActions().showEdit && canEdit()) {
      <button mat-menu-item (click)="emitEdit(row)" [disabled]="rowActions().editDisabled?.(row) ?? false">
        <mat-icon>edit</mat-icon>
        <span>{{ 'shared.tableBuilder.edit' | translate }}</span>
      </button>
      }
      @if (rowActions().showDelete && canDelete()) {
      <button mat-menu-item (click)="emitDelete(row)" [disabled]="rowActions().deleteDisabled?.(row) ?? false">
        <mat-icon>delete</mat-icon>
        <span>{{ rowActions().deleteActionLabel ?? ('shared.tableBuilder.delete' | translate) }}</span>
      </button>
      }
      @for (action of extraRowActions(); track action.id) {
      @if (!action.visible || action.visible(row)) {
      <button mat-menu-item (click)="emitCustomAction(action.id, row)"
        [disabled]="action.disabled ? action.disabled(row) : false">
        @if (action.iconType === 'iconify') {
        <i class="iconify mr-2" [attr.data-icon]="action.icon"></i>
        } @else {
        <mat-icon>{{ action.icon }}</mat-icon>
        }
        <span>{{ action.label }}</span>
      </button>
      }
      }
      }
    </mat-menu>
    }
  </div>

  <!-- Pagination: responsive stack -->
  @if (mergedConfig().showPagination && filteredData().length > 0) {
  <div
    class="table-builder-pagination flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center justify-between gap-3 border-t border-gray-200 px-3 py-3 sm:px-4 dark:border-dark-border">
    <div class="text-sm text-gray-600 dark:text-dark-text-secondary sm:text-start text-center">
      {{ 'shared.tableBuilder.recordsFound' | translate: { count: filteredData().length } }}
    </div>
    <div class="flex flex-wrap items-center justify-center sm:justify-end gap-4 sm:gap-8">
      @if (mergedConfig().showPerPage) {
      <div class="flex items-center gap-2">
        <app-dropdown [label]="'shared.tableBuilder.perPage' | translate" [options]="pageSizeDropdownOptions()" [value]="pageSize()" placeholder="10"
          minWidth="65px" position="top" [overlay]="true" [autoFlip]="true"
          (valueChange)="onPageSizeChange($event)" />
      </div>
      }
      <p class="text-sm text-gray-600 dark:text-dark-text-secondary whitespace-nowrap">
        {{ paginationRange().start }} – {{ paginationRange().end }}
        {{ 'shared.tableBuilder.of' | translate }} {{ paginationRange().total }}
      </p>
      <div class="flex items-center gap-1">
        <button type="button" (click)="goToPage(currentPage() - 1)" [disabled]="currentPage() <= 1"
          class="rounded-full hover:bg-gray-200 dark:hover:bg-gray-600 focus:bg-gray-200 dark:focus:bg-gray-600 p-2 flex items-center justify-center text-sm font-medium text-gray-700 disabled:opacity-50 dark:text-dark-text-secondary">
          <i class="iconify" data-icon="solar:alt-arrow-left-line-duotone"></i>
        </button>
        <button type="button" (click)="goToPage(currentPage() + 1)" [disabled]="currentPage() >= totalPages()"
          class="rounded-full hover:bg-gray-200 dark:hover:bg-gray-600 focus:bg-gray-200 dark:focus:bg-gray-600 p-2 flex items-center justify-center text-sm font-medium text-gray-700 disabled:opacity-50 dark:text-dark-text-secondary">
          <i class="iconify" data-icon="solar:alt-arrow-right-line-duotone"></i>
        </button>
      </div>
    </div>
  </div>
  }
</div>
